module.exports = __webpack_public_path__ + "img/tubiao-19.94bc3236.png";